import moment from 'moment';

export const isNewYearDiscountEnabled =
  moment() >=
    moment(
      process.env.REACT_APP_NEW_YEAR_DISCOUNT_START_DATE_2026,
      'YYYY-MM-DD'
    ).startOf('day') &&
  moment() <=
    moment(
      process.env.REACT_APP_NEW_YEAR_DISCOUNT_END_DATE_2026,
      'YYYY-MM-DD'
    ).endOf('day');

export const getNewYearDiscountAmountData = (data: {
  userRegistrationDate: string;
  amount: number;
}) => {
  const { userRegistrationDate, amount } = data;

  if (!userRegistrationDate) return undefined;

  let newAmount = amount;
  let previousAmount: number | undefined;

  const discountPercentage = 10;
  const percentageAmount = (amount * discountPercentage) / 100;
  const userRegistrationDateMoment = moment(userRegistrationDate);
  const minDate = moment(
    process.env.REACT_APP_NEW_YEAR_DISCOUNT_START_DATE_2026,
    'YYYY-MM-DD'
  ).startOf('day');

  const maxDate = moment(
    process.env.REACT_APP_NEW_YEAR_DISCOUNT_END_DATE_2026,
    'YYYY-MM-DD'
  ).endOf('day');

  const isInRange = userRegistrationDateMoment.isBetween(
    minDate,
    maxDate,
    undefined,
    '[]'
  );

  if (isNewYearDiscountEnabled) {
    if (isInRange) {
      previousAmount = amount + percentageAmount;
    } else if (
      userRegistrationDateMoment < minDate &&
      userRegistrationDateMoment < maxDate
    ) {
      previousAmount = amount;
      newAmount = previousAmount - percentageAmount;
    }
  }

  return {
    previousAmount,
    amount: newAmount,
  };
};

export default getNewYearDiscountAmountData;
